import { ELinkVariant, ETextStyleVariant, Link, Text } from '@outdoorsyco/bonfire';
import React from 'react';

import { IAddress } from '@/components/route/campground/campgroundTypes';
import MapStatic from '@/components/ui/MapStatic/MapStatic';
import { formatAddress } from '@/utility/address';
import { ICoordinates } from '@/utility/commonDataTypes';

type TMapSize = {
  width: number;
  height: number;
};

const mapSizes: TMapSize[] = [
  { width: 576, height: 350 },
  { width: 700, height: 425 },
  { width: 920, height: 559 },
];

type TLocationMapProps = {
  location: ICoordinates;
  address: IAddress;
};

export const LocationMap = ({ location, address }: TLocationMapProps) => {
  return (
    <div className="flex flex-col flex-1 gap-4 md:ml-16">
      <MapStatic
        className="w-full overflow-hidden border border-gray-200 rounded-xl"
        viewport={{ lat: location.lat, lon: location.lon, zoom: 10 }}
        overlay={[
          {
            lat: location.lat,
            lon: location.lon,
            url: 'https://d1o5877uy6tsnd.cloudfront.net/img/location-map-pins/rv-bundle.png',
          },
        ]}
        sourceSizes={mapSizes}
        showFigcaption={false}
      />

      <Link
        variant={ELinkVariant.Underline}
        href={`https://www.google.com/maps/search/?q=${address.street},${address.city},${address.state} ${address.postal_code}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-center">
        <Text variant={ETextStyleVariant.MediumRegular}>
          {formatAddress({
            address: {
              street1: address.street,
              city: address.city,
              state: address.state,
              zip: address.postal_code,
              countryCode: address.country,
            },
            showCountry: false,
          })}
        </Text>
      </Link>
    </div>
  );
};
